import { Card, Col, Row, Skeleton } from "antd";
import academies from "assets/academies.svg";
import courtsIcon from "assets/courts.svg";
import facilitesIcon from "assets/facilites.svg";
import locationIcon from "assets/Location.svg";
import dayjs from "dayjs";
import CardSkeletonView from "features/dashboard/components/Skeleton/skeletonView";
import { useGetDashBoardList } from "features/dashboard/use-cases/get-dashboardUserBehaviour";
import { cardColorsFacilites, monthNameToNumber } from "features/facilities";
import { Fragment } from "react";

import AreaChartView from "./AreaChart";
import { FacilitesBookingData } from "./Facilites-Booking";
import { NormalBookingGraph } from "./normal-booking";
import PackageChartView from "./package-view";
import PieChartExample from "./pie-chart-view";
import { SocialMatchBarChartView } from "./social-match";

const GraphClientsInfo = ({
  selectedMonth,
  selectedYear,
  dateRange,
  facilityId,
}: any) => {
  const today = dayjs();
  // If "All" is selected, selectedMonth will be null
  // Otherwise convert month short name to number
  const monthNumber =
    selectedMonth === null
      ? null
      : typeof selectedMonth === "string"
      ? monthNameToNumber(selectedMonth)
      : null;

  const from = dateRange?.[0]
    ? dayjs(dateRange[0]).format("YYYY-MM-DD")
    : today.startOf("month").format("YYYY-MM-DD");

  const to = dateRange?.[1]
    ? dayjs(dateRange[1]).format("YYYY-MM-DD")
    : today.endOf("month").format("YYYY-MM-DD");

  const iconMap: Record<string, string> = {
    "Number Of Facilities": facilitesIcon,
    Courts: courtsIcon,
    Location: locationIcon,
    "Number Of Academies": academies,
  };
  const desiredOrder = [
    "Location",
    "Number Of Facilities",
    "Courts",
    "Number Of Academies",
  ];

  const GetDashboardData = (flag: string) => {
    const params: any = {
      Type: "Facilities",
      Month: monthNumber,
      Year: selectedYear,
      Flag: flag,
      facilityId: facilityId,
    };

    // Add date range only if "All" is not selected
    if (selectedMonth !== null && dateRange?.[0] && dateRange?.[1]) {
      params.FromDate = from;
      params.EndDate = to;
    }

    return useGetDashBoardList(params);
  };

  const { data: facilitesdata, isLoading: kpiLoading } =
    GetDashboardData("KPI");
  const { data: areadata, isLoading: areaLoading } = GetDashboardData("Area");
  const { data: paymentfacilitesdata, isLoading: paymentfacilites } =
    GetDashboardData("Payment");
  const { data: bookingfacilitesdata, isLoading: BookingFetching } =
    GetDashboardData("Booking");
  const { data: bookingPackagesdata, isLoading: packageLoading } =
    GetDashboardData("Package");
  const { data: socilaMatchdata, isLoading: IsSocialLoading } =
    GetDashboardData("SocialMatch");
  const { data: normalBookingdata, isLoading: IsNormalLoading } =
    GetDashboardData("NormalBooking");
  const sortedItems = facilitesdata?.items?.slice().sort((a: any, b: any) => {
    return desiredOrder.indexOf(a.Name) - desiredOrder.indexOf(b.Name);
  });

  return (
    <Fragment>
      <Row
        gutter={[16, 16]}
        style={{ marginBottom: 24 }}
        className="card_row_main"
      >
        {kpiLoading
          ? Array.from({ length: 4 }).map((_, index) => (
              <CardSkeletonView key={index} />
            ))
          : sortedItems.map((item: any) => (
              <Col span={6} key={item.Name}>
                <Card
                  style={{
                    backgroundColor: cardColorsFacilites[item.Name] || "#fff",
                  }}
                  className="bh_card"
                >
                  <div>
                    <span style={{ fontSize: 16, color: "#fff" }}>
                      {item?.Name}
                    </span>
                    <div className="use_bx_b">
                      <h4 style={{ fontSize: 28, margin: 0, color: "#fff" }}>
                        {item?.Value}
                      </h4>
                      <img
                        src={iconMap[item?.Name] || ""}
                        alt={item?.Name}
                        style={{ width: 32, height: 32 }}
                      />
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
      </Row>

      <Row gutter={[16, 16]} style={{ marginBottom: 24 }} className="graph_row">
        <Col span={24}>
          {areaLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <AreaChartView data={areadata} />
          )}
        </Col>
        <Col span={24}>
          {IsNormalLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <NormalBookingGraph data={normalBookingdata} />
          )}
        </Col>
        <Col span={12}>
          {packageLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <PackageChartView data={bookingPackagesdata} />
          )}
        </Col>
        <Col span={12}>
          {IsSocialLoading ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <SocialMatchBarChartView data={socilaMatchdata} />
          )}
        </Col>
        <Col span={12}>
          {BookingFetching ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <FacilitesBookingData data={bookingfacilitesdata} />
          )}
        </Col>
        <Col span={12}>
          {paymentfacilites ? (
            <Skeleton active paragraph={{ rows: 6 }} />
          ) : (
            <PieChartExample data={paymentfacilitesdata} />
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default GraphClientsInfo;
